import axios from "../../../axios";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import urls from "../../../Utils/urls";
import FormBox from "../../../components/FormBox/FormBox";
import { commonToast } from "../../../Utils";
import { oracleConfig, roleType } from "../../../Utils/constant";
import { useAbortController } from "../../../hooks/useAbortController";
import { roleCreateUserValidations } from "../../../Utils/formOptions";

const RoleCreateUser = ({ update = false }) => {
  const userId = localStorage.getItem("apex_userid");
  const { type, role_id } = useParams();
  const [moduleOptions, setModuleOptions] = useState([]);
  const { signal } = useAbortController();

  const selectedRoleValue = useSelector(
    (state) => state.account.selectedRole.value
  );
  // const selectedRoleLabel = useSelector(
  //   (state) => state.account.selectedRole.label
  // );

  let roleTypeOptionsArr;

  // if (selectedRoleLabel === "Lender Admin" && selectedRoleValue === "L") {
  //   roleTypeOptionsArr = [
  //     { label: "Lender Admin", value: "L" },
  //     { label: "Lender", value: "L" },
  //   ];
  // } else if (
  //   selectedRoleLabel === "Broker Admin" &&
  //   selectedRoleValue === "V"
  // ) {
  //   roleTypeOptionsArr = [
  //     { label: "Lender Admin", value: "L" },
  //     { label: "Lender", value: "L" },
  //   ];
  // }
  if (selectedRoleValue === "L") {
    roleTypeOptionsArr = [{ label: "Lender", value: "L" }];
  } else if (selectedRoleValue === "V") {
    roleTypeOptionsArr = [{ label: "Broker", value: "V" }];
  } else if (selectedRoleValue === "B") {
    roleTypeOptionsArr = [{ label: "Borrower", value: "B" }];
  } else {
    roleTypeOptionsArr = [
      { label: "Lender", value: "L" },
      { label: "Broker", value: "V" },
    ];
  }

  const [reportOptions, setReportOptions] = useState([]);

  const {
    handleSubmit,
    register,
    watch,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      roleName: "",
      roleDescription: "",
      isActive: "",
      parentRole: "",
      roleLevel: "",
      roleType: "",
      moduleAccess: "",
      reports: "",
    },
    ...roleCreateUserValidations,
  });

  const enableReports = watch("moduleAccess");

  const navigate = useNavigate();

  const removeLeadingColon = (value) => {
    if (typeof value === "string" && value.startsWith(":")) {
      return value.slice(1);
    }
    return value;
  };
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(
          urls.dashboard.getSingleRole(userId, role_id),
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Basic UkVTVEFQSUxPQU5MSU5ROjg4V2VIZWxwVSQjQA==",
            },
          },
          { signal }
        );
        if (res) {
          const updatedObj = transformNewApiResponse(res.data);
          Object.keys(updatedObj)?.forEach((key) => {
            setValue(key, updatedObj[key]);
          });
        }
      } catch (error) {
        console.error(error);
      }
    };
    role_id && fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setValue, role_id]);
  const onSubmit = async (data) => {
    const id = toast.loading(`Role ${type} Pending`);
    try {
      const res = await axios.post(
        urls.dashboard.postRole(),
        {
          Role_Name: data?.roleName,
          Role_Description: data?.roleDescription,
          Is_Active: data?.isActive,
          Parent_Role: selectedRoleValue === roleType.lenderAdmin ? "1" : "41",
          Role_Level: 2,
          Role_Type: data?.roleType,
          User_ID: localStorage.getItem("apex_userid"),
          Report_ID: removeLeadingColon(data?.reports),
          Module_ID: removeLeadingColon(data?.moduleAccess),
          Operation: type === "Create" ? "I" : "U",
        },
        oracleConfig
      );

      toast.update(id, {
        render: `Role ${type}d successfully`,
        type: "success",
        isLoading: false,
        ...commonToast,
      });
      navigate("/role-menu");
    } catch (error) {
      toast.update(id, {
        render: `Role ${type === "Create" ? "creation" : "updation"} failed`,
        type: "error",
        isLoading: false,
        ...commonToast,
      });
      console.error(error);
    } finally {
      // Dismiss the loading toast after a delay
      setTimeout(() => {
        toast.dismiss();
      }, 3000);
    }

    // setRolesTableData(data);
  };

  useEffect(() => {
    const detailRole = JSON.parse(
      JSON.parse(localStorage?.getItem("user-details"))?.details?.roles
    )?.filter((data) => data?.role_type === selectedRoleValue)[0];

    const updatedRoute =
      detailRole?.nav_menu
        ?.sort((a, b) => a?.menu_order - b?.menu_order)
        .map((data) => ({
          label: data.menu_name,
          value: data.menu_id,
        })) || [];
    const reportNameList =
      detailRole?.report_list?.map((data) => ({
        label: data.rep_name,
        value: data.rep_id,
      })) || [];

    setReportOptions(reportNameList);
    setModuleOptions(updatedRoute);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedRoleValue]);
  return (
    <section
      className="rounded"
      style={{ background: "#eeeeee", minHeight: "100vh", padding: "10px" }}
    >
      <article className="container-fluid">
        <div className="p-3 pb-0  mt-1">
          <h6>
            <span
              className="linkClick"
              role="button"
              onClick={() => navigate("/role-menu")}
            >
              Role menu
            </span>{" "}
            / {type} role
          </h6>
        </div>
        <form className="bg-white" onSubmit={handleSubmit(onSubmit)}>
          <div className="p-5">
            <div className="row">
              <div className="mb-4">
                <h4>Role Information</h4>
              </div>
              <FormBox
                options={[
                  {
                    title: "Role Name",
                    field: "roleName",
                    type: "text",
                    // className: "col-4",
                    className: "col-6",
                  },
                  // {
                  //   title: "Role Level",
                  //   field: "roleLevel",
                  //   type: "select",
                  //   className: "col-4",
                  //   options: [
                  //     { label: "Reader", value: "1" },
                  //     { label: "Contributor", value: "2" },
                  //     { label: "Admin", value: "3" },
                  //     { label: "Super Admin", value: "4" },
                  //   ],
                  // },
                  {
                    title: "Role Type",
                    field: "roleType",
                    type: "select",
                    // className: "col-4",
                    className: "col-6",
                    options: roleTypeOptionsArr,
                    // options: [
                    //   { label: "Broker", value: "V" },
                    //   { label: "Borrower", value: "B" },
                    //   { label: "Lender", value: "L" },
                    //   {
                    //     label: "Customer Servicing",
                    //     value: "C",
                    //   },
                    //   { label: "Admin", value: "A" },
                    // ],
                  },
                  {
                    title: "Role Description",
                    field: "roleDescription",
                    type: "textarea",
                    className: "col-6",
                  },
                  {
                    title: "Is Active?",
                    field: "isActive",
                    type: "radio",
                    options: [
                      { title: "Yes", value: "Y" },
                      { title: "No", value: "N" },
                    ],
                    className: "col-6",
                  },
                  {
                    type: "content",
                    content: (
                      <div className="my-5 py-3">
                        <h4>Permissions</h4>
                      </div>
                    ),
                  },
                  {
                    title: "Module Access",
                    field: "moduleAccess",
                    type: "switchList",
                    options: moduleOptions,
                    className: "col-4",
                  },
                  {
                    title: "Reports",
                    field: "reports",
                    type: "switchList",
                    options: reportOptions,
                    className: "col-6",
                    disabled: enableReports?.includes(3) ? false : true,
                    source: "role management",
                  },
                ]}
                register={register}
                watch={watch}
                setValue={setValue}
                errors={errors}
              />
            </div>
            <div className="d-flex justify-content-end mt-5">
              <button
                type="button"
                className="btn btn-secondary me-3"
                onClick={() => navigate("/role-menu")}
              >
                Cancel
              </button>
              <button type="submit" className="btn btn-primary text-white">
                {type} Role
              </button>
            </div>
          </div>
        </form>
      </article>
    </section>
  );
};
export default RoleCreateUser;
function transformNewApiResponse(apiResponse) {
  let transformedObj = {
    roleName: "",
    roleId: "",
    roleType: "",
    roleDescription: "",
    isActive: "",
    parentRoleId: "",
    roleLevel: "",
    moduleAccess: "",
    reports: "",
  };
  if (apiResponse.items && apiResponse.items.length > 0) {
    const role = apiResponse.items[0];

    // Assign values
    transformedObj.roleName = role.role_name || "";
    transformedObj.roleId = role.role_id || "";
    transformedObj.roleType = role.role_type || "";
    transformedObj.roleDescription = role.role_description || "";
    transformedObj.isActive = role.is_active || "";
    transformedObj.parentRoleId = role.parent_role_id || "";
    transformedObj.roleLevel = `${role.role_level}` || "";

    // Extract moduleAccess and reports
    transformedObj.moduleAccess = role.modules
      ? role.modules.replace(/^:|:$/g, "")
      : ""; // Removing leading and trailing colons
    transformedObj.reports = role.reports
      ? role.reports.replace(/^:|:$/g, "")
      : ""; // Removing leading and trailing colons
  }

  return transformedObj;
}
